module.exports = __webpack_public_path__ + "img/icon_006.2ee5d1a.png";